export {CalendarSvg} from './calendar'
export {DeviceSvg} from './device'
export {TypeSvg} from './type'
export {CategorySvg} from './category'
export {BackToAppsSvg} from './backToApps'